module.exports = __webpack_public_path__ + "img/女团队协作.798dee74.png";